<script setup lang="ts">
import getSubDomainInitial from '../../../../helpers/getSubDomainInitial';
import { ref } from 'vue';
import '../scss/Footer.scss';
import { useI18n } from 'vue-i18n'

const { t } = useI18n();
const subDomainInitial = ref<string>('');
subDomainInitial.value = getSubDomainInitial();
</script>

<template>
  <div>
    <div class="Footer__Chubb" v-if="subDomainInitial === 'CONTEMPORA'">
      <p class="Footer__text">{{ t('landing.components.footer.asegurado_por') }}:</p>
      <img src="/img/Logo-Contempora.png" />
    </div>
    <div class="Footer__Chubb" v-else-if="subDomainInitial !== 'CHILE' && subDomainInitial !== 'SPAIN'">
      <p class="Footer__text">{{ t('landing.components.footer.asegurado_por') }}:</p>
      <img src="/img/logo-chubb.png" />
    </div>
    <div class="Footer__Tryger">
      <p class="Footer__text">{{ t('landing.components.footer.powered_by') }}</p>
      <img src="/img/logo-geomax.png" />
      <div class="links_privacy">
        <div v-if="subDomainInitial === 'CONTEMPORA'">
          <span class="highlight text-white">{{ t('landing.components.footer.terminos_y_condiciones') }}</span
          >
          <span class="highlight text-white"> |</span>
          <span class="text-white">{{ t('landing.components.footer.politica_de_privacidad') }}</span
          >
        </div>
        <div v-else-if="subDomainInitial !== 'CHILE'">
          <a
            href="https://www.chubb.com/content/dam/chubb-sites/chubb-com/mx-es/condiciones-generales/global/documents/pdf/ad33-aba-d-transporte-de-carga-especifica.pdf"
            target="_blank"
            >{{ t('landing.components.footer.terminos_y_condiciones') }}</a
          >
          <span class="highlight"> |</span>
          <a
            href="https://www.chubb.com/content/dam/chubb-sites/chubb-com/mx-es/footer/privacy-notices/documents/pdf/aviso-de-privacidad-asegurados-chubb-seguros-mexico.pdf"
            target="_blank"
            >{{ t('landing.components.footer.politica_de_privacidad') }}</a
          >
        </div>
      </div>
    </div>
  </div>
</template>
